import InputField from '../components/Fields/InputField';
import DatePickerField from '../components/Fields/DatePickerField';
import WYSIWYGField from '../components/Fields/WYSIWYGField';
import InternalLinkField from '../components/Fields/InternalLinkField';
import ExternalLinkField from '../components/Fields/ExternalLinkField';
import DropdownField from '../components/Fields/DropdownField';
import ImageField from '../components/Fields/ImageField';
import ImageFieldWithOpacity from '../components/Fields/ImageFieldWithOpacity';
import FileField from '../components/Fields/FileField';
import ExternalVideoField from '../components/Fields/ExternalVideoField';
import BlockAreaField from '../components/Fields/BlockAreaField';
import BlockField from '../components/Fields/BlockField';
import SelectField from '../components/Fields/SelectField';
import MenuField from '../components/Fields/MenuField';
import TemplateField from '../components/Fields/TemplateField';
import ListField from '../components/Fields/ListField';
import TextareaField from '../components/Fields/TextareaField';
import HeroField from '../components/Fields/HeroField';
import ToggleField from "../components/Fields/ToggleField";
import FormStructureField from "../components/Fields/FormStructureField";
import NewsArticleContentField from '../components/Fields/NewsArticleContentField';
import NewsListingAttributesField from '../components/Fields/NewsListingAttributesField';
import CornerstoneWidgetField from '../components/Fields/CornerstoneWidgetField';
import { CardGridField } from '../components/CardGrid';
import { QAField } from '../components/QA';
import NewLinkField from '../components/Fields/NewLinkField';
import UnitField from '../components/Fields/Unit';
import CONSTANTS from '../config/constants.js';

export default {
    '0': {
        'inputType': '',
        'type': 'None',
        'component': '',
        'props': {
            omitCollapsible: false
        },
        'defaultValue': ''
    },
    '1': {
        'inputType': 'text',
        'type': 'String',
        'component': InputField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': ''
    },
    '2': {
        'inputType': 'textarea',
        'type': 'LongString',
        'component': TextareaField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': ''
    },
    '3': {
        'inputType': '',
        'type': 'HtmlString',
        'component': WYSIWYGField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': ''
    },
    '4': {
        'inputType': '',
        'type': 'ImageField',
        'component': ImageField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '5': {
        'inputType': '',
        'type': 'File',
        'component': FileField,
        'props': {
            defaultFileType: 'documents',
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '6': {
        'inputType': '',
        'type': 'ExternalVideo',
        'component': ExternalVideoField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '7': {
        'inputType': '',
        'type': 'InternalLink',
        'component': InternalLinkField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '8': {
        'inputType': '',
        'type': 'ExternalLink',
        'component': ExternalLinkField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '9': {
        'inputType': '',
        'type': 'Dropdown',
        'component': DropdownField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '10': {
        'inputType': '',
        'type': 'Block',
        'component': BlockField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '11': {
        'inputType': '',
        'type': 'Blockarea',
        'component': BlockAreaField,
        'props': {
            region: 'main'
        },
        'defaultValue': []
    },
    '12': {
        'inputType': 'toggle',
        'type': 'Boolean',
        'component': ToggleField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': false
    },
    '13': {
        'inputType': 'date',
        'type': 'Date',
        'component': DatePickerField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '14': {
        'inputType': '',
        'type': 'Width',
        'component': SelectField,
        'props': {
            items: CONSTANTS.BLOCK_WIDTH_DROPDOWN,
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '15': {
        'inputType': 'number',
        'type': 'number',
        'component': InputField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': ''
    },
    '16': {
        'inputType': '',
        'type': 'Template',
        'component': TemplateField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': []
    },
    '17': {
        'inputType': '',
        'type': 'List',
        'component': ListField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': []
    },
    '18': {
        'inputType': '',
        'type': 'Width',
        'component': MenuField,
        'props': {
            items: [],
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '19': {
        'inputType': '',
        'type': 'Sort Order',
        'component': SelectField,
        'props': {
            items: CONSTANTS.PAGE_ITEMS_ORDER_DROPDOWN,
            omitCollapsible: true,
            defaultValue: {
                title: "Newest",
                id: 'desc'
            }
        }
    },
    '20': {
        'inputType': '',
        'type': 'Hero',
        'component': HeroField,
        'props': {
            omitCollapsible: false
        }
    },
    '21': {
        'inputType': '',
        'type': 'ImageField',
        'component': ImageField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': null
    },
    '22': {
        'inputType': '',
        'type': 'FormFields',
        'component': FormStructureField,
        'props': {
            omitCollapsible: false
        },
        'defaultValue': []
    },
    // '23': {
    //     'inputType': '',
    //     'type': 'FormFields',
    //     'component': InputField,
    //     'props': {
    //         omitCollapsible: true
    //     },
    //     'defaultValue': []
    // }
    '24': {
        'inputType': '',
        'type': 'ImageFieldWithOpacity',
        'component': ImageFieldWithOpacity,
        'props': {
            omitCollapsible: false
        },
    },
    '25': {
        'inputType': '',
        'type': 'NewsArticleContent',
        'component': NewsArticleContentField,
        'props': {
            omitCollapsible: false
        },
    },
    '26': {
        'inputType': '',
        'type': 'NewsListingAttributes',
        'component': NewsListingAttributesField,
        'props': {
            omitCollapsible: false
        },
    },
    27: {
        inputType: '',
        type: 'CornerstoneWidgetField',
        component: CornerstoneWidgetField,
        props: {
            omitCollapsible: false
        }
    },
    28: {
        inputType: '',
        type: 'NewLinkField',
        component: NewLinkField,
        props: {
            omitCollapsible: false
        }
    },
    29: {
        inputType: '',
        type: 'UnitField',
        component: UnitField,
        props: {
            omitCollapsible: false
        }
    },
    30: {
        inputType: '',
        type: 'CardGridField',
        component: CardGridField,
        props: {
            omitCollapsible: false
        }
    },
    31: {
        inputType: '',
        type: 'QAField',
        component: QAField,
        props: {
            omitCollapsible: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/core/admin/config/fieldDefinitionTypes.js